import React, { useRef, useState, useEffect } from "react";
import "../styles/forms.sass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import emailjs from "@emailjs/browser";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Forms = () => {
  const form = useRef(null);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=your-site-key";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const sendEmail = async (event) => {
    event.preventDefault();

    if (!executeRecaptcha) {
      console.log("Błąd weryfikacji reCAPTCHA");
      return;
    }

    const token = await executeRecaptcha("contact_form");

    if (!token) {
      alert("Proszę zaznaczyć reCAPTCHA.");
      return;
    }

    if (!form.current) return;

    const recaptchaInput = document.createElement("input");
    recaptchaInput.type = "hidden";
    recaptchaInput.name = "recaptchaToken";
    recaptchaInput.value = token;
    form.current.appendChild(recaptchaInput);

    emailjs
      .sendForm(
        "service_1h1ta6i",
        "contact_form",
        form.current,
        "JrE9jWQ2Pmeh_RLcH"
      )
      .then(() => {
        alert("Wiadomość została wysłana!");
        form.current.reset();
        setName("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.log("FAILED...", error);
      })
      .finally(() => {
        form.current.removeChild(recaptchaInput);
      });
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <label htmlFor='imie'>
        Imię
        <input
          type='text'
          maxLength={30}
          minLength={3}
          onChange={(e) => setName(e.target.value)}
          value={name}
          style={{ color: name.length >= 3 ? "black" : "red" }}
          required
          name='user_name'
          id='imie'
        />
      </label>
      <label htmlFor='email'>
        E-mail
        <input
          type='email'
          maxLength={30}
          minLength={5}
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          name='user_email'
          style={{
            color: email.length >= 5 && email.includes("@") ? "black" : "red",
          }}
          required
          id='email'
        />
      </label>
      <label htmlFor='wiadomosc'>
        Wiadomość...
        <textarea
          maxLength={100}
          minLength={10}
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          style={{
            color: message.length > 10 ? "black" : "red",
          }}
          required
          name='message'
          id='wiadomosc'
        ></textarea>
      </label>
      <p>{message.length}/100</p>

      <button aria-label='Wyślij' className='send' type='submit'>
        Wyślij <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </form>
  );
};

export default Forms;
